import {Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-base-unit-view-log',
  templateUrl: './base-unit-view-log.component.html',
})
export class BaseUnitViewLogComponent {
  constructor(
    public activatedRoute: ActivatedRoute
  ) {
  }
}
